{
    "LoadingLabel": "[Loading...]",
    "NAME": "ComboBox"
}